var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternationalBannerLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 180 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 87.0001C112 87.0001 97.9928 42.057 61.821 46.4237C50.9596 47.7484 34.5423 24.3569 26.5229 16.0686C18.5036 7.78032 0.000930786 9.53729 0.000930786 23.5273C0.000930786 37.5172 0.000930786 87.0001 0.000930786 87.0001H142.667Z",
    fill: "url(#paint0_linear_696_17388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M42.8704 34.6271C34.0855 24.7881 36.8967 27.2479 27.409 17.0574C17.9214 6.867 0.000228882 9.94449 0.000228882 23.9345C0.000228882 37.9244 4.57764e-05 40.6008 4.57764e-05 40.6008C3.53679 40.0956 7.34261 26.4123 8.78512 34.6271C10.5421 44.6327 18.1303 31.3431 20.3811 31.1132C23.8951 30.7543 31.2744 43.412 32.3283 31.1132C35.1396 29.7076 39.7078 38.4925 42.8704 34.6271Z",
    fill: "url(#paint1_linear_696_17388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.68 66.1822C160.712 66.1822 158.88 65.4088 157.496 63.9976C156.112 62.5864 155.38 60.7275 155.434 58.7465C155.475 56.874 156.235 55.11 157.578 53.7803C158.921 52.4506 160.699 51.7043 162.571 51.6771C164.335 51.65 166.058 52.2606 167.388 53.4139C168.324 54.2145 169.681 54.3773 170.74 53.821C171.676 53.3325 172.734 53.1019 173.793 53.1561C176.737 53.3325 179.071 55.6935 179.206 58.6515C179.274 60.239 178.718 61.7587 177.619 62.9121C176.52 64.0654 175.041 64.7032 173.44 64.7032C172.49 64.7032 171.567 64.4861 170.794 64.0654C169.681 63.4956 168.324 63.6448 167.402 64.4318C166.099 65.558 164.416 66.1822 162.68 66.1822ZM162.693 53.0476C162.666 53.0476 162.625 53.0476 162.598 53.0476C159.464 53.1019 156.872 55.6664 156.791 58.7872C156.75 60.3883 157.347 61.908 158.473 63.0478C159.586 64.1876 161.079 64.8253 162.68 64.8253C164.091 64.8253 165.461 64.3232 166.52 63.4006C167.849 62.2608 169.83 62.0437 171.418 62.8578C172.015 63.1699 172.707 63.3327 173.44 63.3327C174.661 63.3327 175.787 62.8443 176.628 61.9623C177.47 61.0803 177.904 59.927 177.85 58.7058C177.741 56.4805 175.923 54.6351 173.711 54.513C172.897 54.4723 172.083 54.6487 171.364 55.0151C169.817 55.8428 167.849 55.6121 166.493 54.4452C165.448 53.5496 164.104 53.0476 162.693 53.0476Z",
    fill: "#F9D5FF",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3241 21.3648C98.2219 21.3648 100.92 20.2256 102.958 18.1473C104.997 16.0689 106.076 13.331 105.996 10.4132C105.936 7.65536 104.817 5.05737 102.838 3.09888C100.86 1.1404 98.2419 0.0412461 95.484 0.00127696C92.886 -0.0386922 90.348 0.860613 88.3895 2.5593C87.0105 3.73839 85.0121 3.9782 83.4533 3.15884C82.0743 2.43939 80.5155 2.09966 78.9568 2.1796C74.6201 2.43939 71.1828 5.91671 70.9829 10.2733C70.883 12.6115 71.7024 14.8498 73.3211 16.5485C74.9399 18.2472 77.1182 19.1864 79.4763 19.1864C80.8753 19.1864 82.2342 18.8667 83.3733 18.2472C85.0121 17.4078 87.0105 17.6277 88.3695 18.7868C90.288 20.4455 92.7661 21.3648 95.3241 21.3648ZM95.3041 2.01972C95.3441 2.01972 95.404 2.01972 95.444 2.01972C100.06 2.09966 103.877 5.87674 103.997 10.4732C104.057 12.8314 103.178 15.0696 101.519 16.7483C99.8806 18.427 97.6823 19.3663 95.3241 19.3663C93.2457 19.3663 91.2273 18.6269 89.6685 17.2679C87.71 15.5892 84.7922 15.2695 82.4541 16.4685C81.5747 16.9282 80.5555 17.168 79.4763 17.168C77.6777 17.168 76.019 16.4486 74.78 15.1496C73.5409 13.8506 72.9014 12.1519 72.9814 10.3533C73.1412 7.07581 75.8192 4.35791 79.0767 4.17805C80.2757 4.1181 81.4748 4.3779 82.534 4.91748C84.8122 6.13654 87.71 5.7968 89.7084 4.07813C91.2473 2.75915 93.2257 2.01972 95.3041 2.01972Z",
    fill: "#F9D5FF",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.042 86.9746V52.5584C113.042 51.7861 113.685 51.1426 114.458 51.1426C115.23 51.1426 115.873 51.7861 115.873 52.5584V86.9746H113.042Z",
    fill: "url(#paint2_linear_696_17388)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 63.1126C114.38 63.1126 114.303 63.1126 114.226 63.0868C113.454 62.9581 112.939 62.2373 113.068 61.4651C113.711 57.6553 117.109 54.9781 120.97 55.2612C121.743 55.3127 122.335 56.0078 122.283 56.78C122.232 57.5523 121.537 58.1444 120.764 58.0929C118.37 57.9127 116.26 59.5602 115.848 61.9285C115.745 62.6235 115.127 63.1126 114.458 63.1126Z",
    fill: "#CAE6C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 63.1127C113.788 63.1127 113.171 62.6237 113.068 61.9286C112.681 59.5603 110.571 57.9128 108.151 58.093C107.379 58.1445 106.684 57.5782 106.632 56.7802C106.581 56.0079 107.147 55.3129 107.945 55.2614C111.832 54.9783 115.23 57.6297 115.848 61.4652C115.976 62.2375 115.462 62.9583 114.689 63.087C114.612 63.1128 114.535 63.1127 114.458 63.1127Z",
    fill: "#CAE6C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 70.2176C114.38 70.2176 114.303 70.2176 114.226 70.1918C113.454 70.0631 112.939 69.3424 113.068 68.5701C113.711 64.7602 117.109 62.0831 120.97 62.3662C121.743 62.4177 122.335 63.1127 122.283 63.885C122.232 64.6573 121.537 65.2493 120.764 65.1979C118.37 65.0177 116.26 66.6652 115.848 69.0334C115.745 69.7285 115.127 70.2176 114.458 70.2176Z",
    fill: "#CAE6C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.458 70.2175C113.788 70.2175 113.171 69.7284 113.068 69.0334C112.681 66.6651 110.571 65.0176 108.151 65.1978C107.379 65.2493 106.684 64.683 106.632 63.8849C106.581 63.1127 107.147 62.4176 107.945 62.3662C111.806 62.083 115.23 64.7344 115.848 68.57C115.976 69.3423 115.462 70.0631 114.689 70.1918C114.612 70.2175 114.535 70.2175 114.458 70.2175Z",
    fill: "#CAE6C4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M138.597 86.9659V71.9822C138.597 71.3486 139.125 70.8206 139.758 70.8206C140.392 70.8206 140.92 71.3486 140.92 71.9822V86.9659H138.597Z",
    fill: "url(#paint3_linear_696_17388)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.758 80.6418C139.695 80.6418 139.631 80.6418 139.568 80.6206C138.934 80.515 138.512 79.9236 138.618 79.29C139.146 76.1642 141.934 73.9676 145.102 74.1999C145.735 74.2422 146.221 74.8124 146.179 75.4461C146.137 76.0797 145.566 76.5655 144.933 76.5232C142.968 76.3754 141.237 77.7271 140.899 79.6702C140.814 80.2405 140.307 80.6418 139.758 80.6418Z",
    fill: "#CAE6C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.758 80.6416C139.209 80.6416 138.702 80.2404 138.617 79.6701C138.301 77.727 136.569 76.3753 134.583 76.5231C133.95 76.5654 133.379 76.1007 133.337 75.446C133.295 74.8123 133.76 74.2421 134.414 74.1998C137.604 73.9675 140.392 76.1429 140.898 79.2899C141.004 79.9235 140.582 80.5149 139.948 80.6205C139.885 80.6417 139.821 80.6416 139.758 80.6416Z",
    fill: "#CAE6C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.758 86.4709C139.695 86.4709 139.631 86.4709 139.568 86.4498C138.934 86.3441 138.512 85.7528 138.618 85.1191C139.146 81.9933 141.934 79.7967 145.102 80.029C145.735 80.0713 146.221 80.6415 146.179 81.2752C146.137 81.9088 145.566 82.3946 144.933 82.3523C142.968 82.2045 141.237 83.5562 140.899 85.4993C140.814 86.0696 140.307 86.4709 139.758 86.4709Z",
    fill: "#CAE6C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.758 86.471C139.209 86.471 138.702 86.0697 138.617 85.4995C138.301 83.5564 136.569 82.2046 134.583 82.3525C133.95 82.3947 133.379 81.9301 133.337 81.2753C133.295 80.6417 133.76 80.0714 134.414 80.0292C137.583 79.7969 140.392 81.9723 140.898 85.1193C141.004 85.7529 140.582 86.3443 139.948 86.4499C139.885 86.471 139.821 86.471 139.758 86.471Z",
    fill: "#CAE6C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_17388",
    x1: 73.2967,
    y1: 23.1912,
    x2: 73.2967,
    y2: 84.4411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACEEDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_696_17388",
    x1: 73.296,
    y1: 0.701997,
    x2: 73.296,
    y2: 61.9518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_696_17388",
    x1: 114.458,
    y1: 51.1426,
    x2: 114.458,
    y2: 102.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#CAE6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4772,
    stopColor: "#CDE7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6541,
    stopColor: "#D6ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    stopColor: "#E5F3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9698,
    stopColor: "#FBFDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_696_17388",
    x1: 139.758,
    y1: 70.8206,
    x2: 139.758,
    y2: 112.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#CAE6C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4772,
    stopColor: "#CDE7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6541,
    stopColor: "#D6ECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    stopColor: "#E5F3E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9698,
    stopColor: "#FBFDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9958,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalBannerLeft);
export default __webpack_public_path__ + "static/media/international-banner-left.51937cb7.svg";
export { ForwardRef as ReactComponent };